export type RouteParam = {
  key: string
  value: string
}

export function getString(params: RouteParam[] | undefined = [], key: string): string | undefined {
  const param = params.find(param => param.key === key)
  return param && param.value ? decodeURI(param.value) : undefined
}

export function getStringOrThrow(params: RouteParam[] = [], key: string) {
  const param = getString(params, key)
  if (!param) {
    throw new Error(`Missing param ${key}`)
  }
  return param
}

export function getValgtype(params: RouteParam[] = []): 'kommune' | 'fylke' {
  const valgtype = getStringOrThrow(params, 'valgtype')
  if (valgtype !== 'kommune' && valgtype !== 'fylke') {
    throw new Error('Ukjent valgtype ' + valgtype)
  }
  return valgtype
}

export function getInteger(params: RouteParam[] = [], key: string): number | undefined {
  const param = params.find(param => param.key === key)
  if (param) {
    const num = Number(param.value)
    if (Number.isInteger(num)) {
      return num
    }
  }
  return undefined
}
